import React, { FC } from 'react';
import FeaturedItem from '@common/components/FeaturedItem';
import { Category } from 'shared-types/Common';
import { Routes } from '@common/constants';
import { FeaturedItemWrapper, GridWrapper } from './CategoryGrid.styles';

type CategoryGridProps = {
  categories: Category[];
  gridHeight?: number;
};

export const CategoryGrid: FC<CategoryGridProps> = ({ categories = [], gridHeight = 400 }) => {
  const categoriesFilteredForPrivate = categories.filter((category) => !category.isPrivate);
  return (
    <GridWrapper>
      {categoriesFilteredForPrivate.map((category, i) => (
        <FeaturedItemWrapper key={category.id} data-testid={`category-grid-item-${i}`}>
          <FeaturedItem
            title={category.name}
            height={gridHeight}
            imageUrl={category.image && category.image.url}
            redirectData={{
              pathname: Routes.CATEGORY_DETAIL,
              query: {
                id: category.id,
              },
            }}
          >
            <h2>{category.name}</h2>
          </FeaturedItem>
        </FeaturedItemWrapper>
      ))}
    </GridWrapper>
  );
};
